import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove Emergent badge
const removeBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) badge.remove();
  
  // Also remove any dynamically injected badges
  document.querySelectorAll('a[href*="emergent.sh"]').forEach(el => {
    if (el.style.position === 'fixed' || el.id === 'emergent-badge') {
      el.remove();
    }
  });
};

// Run on load and observe for dynamic additions
removeBadge();
const observer = new MutationObserver(removeBadge);
observer.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
